<template>
  <generic-modal
    size="large"
    :title="$t('configure modul instance')"
    icon="settings"
    image="/images/icons/settings-1.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class v-if="loading">
      <div class="ui active inverted dimmer">
        <div class="ui text loader">{{ $t("loading") }}</div>
      </div>
      <p></p>
    </div>
    <div class="description" v-if="!loading">
      <generic-container
        :title="$t('enterprise manager')"
        icon="building"
        :show_plus="true"
        @add="add"
      >
        <div class="ui pointing menu" ref="tabs_layouts">
          <a
            class="item"
            :data-tab="lyt.uuid"
            v-for="lyt in enterprises"
            :key="lyt.uuid"
          >
            <i class="building icon"></i>
            {{ lyt.name || $t("unnamed") }}
          </a>
        </div>
        <div
          class="ui enterprise tab segment"
          :data-tab="lyt.uuid"
          v-for="(lyt, idx) in enterprises"
          :key="lyt.uuid"
        >
          <div class="ui four item pointing menu">
            <a class="item active" data-tab="general">
              <i class="circle info icon"></i>
              {{ $t("general") }}
            </a>
            <a class="item" data-tab="users">
              <i class="user icon"></i>
              {{ $t("users") }}
            </a>
            <a class="item" data-tab="roles">
              <i class="users icon"></i>
              {{ $t("roles") }}
            </a>
            <a class="item" data-tab="modules">
              <i class="boxes icon"></i>
              {{ $t("modules") }}
            </a>
          </div>
          <div class="ui bottom attached tab active" data-tab="general">
            <div class="ui form">
              <div class="three fields">
                <div class="field">
                  <label for>{{ $t("name") }}</label>
                  <input
                    type="text"
                    name="name"
                    v-model="enterprises[idx].name"
                  />
                </div>
                <div class="field">
                  <label for>{{ $t("codename") }}</label>
                  <input
                    type="text"
                    name="name"
                    v-model="enterprises[idx].codename"
                  />
                </div>
                <div class="field">
                  <!-- <label for>{{ $t("options") }}</label> -->
                  <div class="ui toggle checkbox">
                    <input
                      type="checkbox"
                      name="status"
                      v-model="enterprises[idx].status"
                    />
                    <label>{{ $t("active") }}</label>
                  </div>
                </div>
              </div>
              <div class>
                <div
                  class="ui blue icon labeled right floated button"
                  @click="save_enterprise(lyt, idx)"
                >
                  <i class="save icon"></i>
                  {{ $t("save") }}
                </div>
                <div
                  class="ui red icon labeled button"
                  @click="remove_enterprise(lyt, idx)"
                >
                  <i class="trash icon"></i>
                  {{ $t("remove") }}
                </div>
              </div>
            </div>
          </div>
          <div class="ui bottom attached tab" data-tab="users">
            <generic-container
              :title="$t('user manager')"
              icon="users"
              :show_plus="true"
              @add="add_user"
            >
              <div class="ui form">
                <div
                  class="three fields"
                  v-for="(usr, idx) in users"
                  :key="usr.uuid"
                >
                  <div class="four column wide field">
                    <label for>{{ $t("name") }}</label>
                    <input type="text" name="name" v-model="users[idx].name" />
                  </div>
                  <div class="four column wide field">
                    <label for>{{ $t("username") }}</label>
                    <input
                      type="text"
                      name="username"
                      v-model="users[idx].username"
                    />
                  </div>
                  <div class="four column wide field">
                    <!-- <label for>{{ $t("options") }}</label> -->
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="status"
                        v-model="users[idx].status"
                      />
                      <label>{{ $t("active") }}</label>
                    </div>
                  </div>
                  <div class="four column wide field">
                    <div class="buttons" style="margin-top: 23px">
                      <div
                        class="ui mini icon blue button"
                        :data-tooltip="$t('save')"
                        @click="save_user(usr, idx)"
                      >
                        <i class="save icon"></i>
                      </div>
                      <div
                        class="ui mini icon red button"
                        :data-tooltip="$t('delete')"
                        @click="remove_user(usr, idx)"
                      >
                        <i class="trash icon"></i>
                      </div>
                      <div
                        class="ui mini icon orange button"
                        :data-tooltip="$t('reset password')"
                        @click="reset_user_password(usr)"
                      >
                        <i class="refresh icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </generic-container>
          </div>
          <div class="ui bottom attached tab" data-tab="roles">
            <generic-container
              :title="$t('roles manager')"
              icon="users"
              :show_plus="true"
              @add="add_role"
            >
              <div class="ui form">
                <div
                  class="three fields"
                  v-for="(rle, idx) in roles"
                  :key="rle.encrypted_id"
                >
                  <div class="eight column wide field">
                    <label for>{{ $t("name") }}</label>
                    <input type="text" name="name" v-model="roles[idx].name" />
                  </div>
                  <div class="four column wide field">
                    <!-- <label for>{{ $t("options") }}</label> -->
                    <div class="ui toggle checkbox">
                      <input
                        type="checkbox"
                        name="status"
                        v-model="roles[idx].status"
                      />
                      <label>{{ $t("active") }}</label>
                    </div>
                  </div>
                  <div class="four column wide field">
                    <div class="buttons" style="margin-top: 23px">
                      <div
                        class="ui mini icon blue button"
                        :data-tooltip="$t('save')"
                        @click="save_role(rle, idx)"
                      >
                        <i class="save icon"></i>
                      </div>
                      <div
                        class="ui mini icon red button"
                        :data-tooltip="$t('delete')"
                        @click="remove_role(rle, idx)"
                      >
                        <i class="trash icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </generic-container>
          </div>
          <div class="ui bottom attached tab" data-tab="modules">
            <modules-manager
              :modules="modules"
              :instance="instance"
              :enterprise_id="selected_enterprise.enterprise_id"
            />
          </div>
        </div>
      </generic-container>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
import GenericContainer from "@/components/GenericContainer";
import ModulesManager from "./ModulManagerConfigureInstanceModulesManager";

export default {
  name: "ModulManagerConfigureInstanceModal",
  components: {
    "generic-modal": GenericModal,
    GenericContainer,
    ModulesManager
  },
  computed: {},
  props: { instance: Object },
  data() {
    return {
      enterprises: [],
      users: [],
      all_users: [],
      roles: [],
      all_roles: [],
      modules: [],
      all_modules: [],
      permissions: [],
      uuid: "",
      selected_enterprise: {},
      loading: true
    };
  },
  methods: {
    finished() {
      // let vm = this;
      return new Promise(function(resolve /*, reject*/) {
        // let isValid = window.jQuery(vm.$refs.form).form("validate form");

        // if (!isValid) reject();
        // else {
        //   local_api(vm, "post", "/modul_manager/do-configure-instance", {
        //     uuid: vm.uuid
        //   })
        //     .then(r => {
        //       vm.$emit("succedded", r);
        resolve();
        //     })
        //     .catch(err => {
        //       reject(err);
        //     });
        // }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    add() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter enterprise name"), "", function(
        element,
        value
      ) {
        local_api(vm, "post", "/modul_manager/do-save-enterprise", {
          n: value,
          e: vm.uuid
        })
          .then(() => {
            vm.reload();
          })
          .catch((err) => {
            vm.$alertify.error(JSON.stringify(err));
          });
      });
      // this.enterprises.push({ name: this.$t("unnamed") });
    },
    reload() {
      let vm = this;
      vm.users = [];
      vm.roles = [];
      vm.enterprise_id = [];
      local_api(vm, "post", "/modul_manager/do-get-instance", {
        u: vm.uuid
      })
        .then((r) => {
          // r.enterprises.map(e => {
          //   vm.enterprises.push(e);
          // });
          vm.enterprises = r.enterprises.map((e) => {
            e.status = e.status_code == "A";
            return e;
          });
          vm.all_users = r.users.map((u) => {
            u.status = u.status_code == "A";
            return u;
          });
          vm.all_roles = r.roles.map((u) => {
            u.status = u.status_code == "A";
            return u;
          });

          vm.all_modules = r.modules.map((m) => {
            m.setup = JSON.parse(m.setup);
            return m;
          });
          vm.permissions = r.module_suscriptions;

          vm.loading = false;

          setTimeout(() => {
            window
              .jQuery(".ui.menu")
              .find(".item")
              .tab();
          }, 1000);
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    add_user() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter username"), "", function(
        element,
        value
      ) {
        local_api(vm, "post", "/modul_manager/do-save-user", {
          n: value,
          e: vm.selected_enterprise.enterprise_id,
          i: vm.uuid
        })
          .then((u) => {
            vm.users.push({
              name: u.name,
              username: u.username
            });
          })
          .catch((err) => {
            vm.$alertify.error(JSON.stringify(err));
          });
      });
    },
    save_user(user) {
      let vm = this;
      local_api(vm, "post", "/modul_manager/do-alter-user", {
        u: {
          n: user.name,
          u: user.username,
          i: user.encrypted_id,
          s: user.status ? "A" : "I"
        },
        i: vm.instance.uuid
      })
        .then(() => {
          vm.$alertify.success(vm.$t("user modified"));
          vm.reload();
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    remove_user(user, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove user?"), function() {
        local_api(vm, "post", "/modul_manager/do-remove-user", {
          u: user.encrypted_id,
          i: vm.instance.uuid
        })
          .then(() => {
            let idx = vm.all_users.findIndex((n) => n.user_id == user.user_id);
            if (idx >= 0) vm.all_users.splice(idx, 1);
            vm.users.splice(index, 1);
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });
      });
    },
    reset_user_password(user) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to reset user password?"),
        function() {
          local_api(vm, "post", "/modul_manager/do-reset-user", {
            u: user.encrypted_id,
            i: vm.instance.uuid
          })
            .then(() => {
              vm.$alertify.success(vm.$t("password reseted"));
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        }
      );
    },
    save_enterprise(enterprise) {
      let vm = this;
      local_api(vm, "post", "/modul_manager/do-alter-enterprise", {
        e: enterprise,
        i: vm.instance.uuid
      })
        .then(() => {
          vm.$alertify.success(vm.$t("enterprise modified"));
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    remove_enterprise(enterprise, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove enterprise?"),
        function() {
          local_api(vm, "post", "/modul_manager/do-remove-enterprise", {
            e: enterprise.uuid,
            i: vm.instance.uuid
          })
            .then(() => {
              vm.enterprises.splice(index, 1);
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            });
        }
      );
    },
    add_role() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter role name"), "", function(
        element,
        value
      ) {
        local_api(vm, "post", "/modul_manager/do-save-role", {
          n: value,
          e: vm.selected_enterprise.enterprise_id,
          i: vm.uuid
        })
          .then(() => {
            vm.reload();
          })
          .catch((err) => {
            vm.$alertify.error(JSON.stringify(err));
          });
      });
    },
    save_role(role) {
      let vm = this;
      local_api(vm, "post", "/modul_manager/do-alter-role", {
        n: role.name,
        s: role.status ? "A" : "I",
        u: role.encrypted_id,
        i: vm.instance.uuid
      })
        .then(() => {
          vm.$alertify.success(vm.$t("role modified"));
          vm.reload();
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    remove_role(role, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove role?"), function() {
        local_api(vm, "post", "/modul_manager/do-remove-role", {
          u: role.encrypted_id,
          i: vm.instance.uuid
        })
          .then(() => {
            let idx = vm.all_roles.findIndex((n) => n.role_id == role.role_id);
            if (idx >= 0) vm.all_roles.splice(idx, 1);
            vm.roles.splice(index, 1);
          })
          .catch((err) => {
            vm.$alertify.error(stringify(err));
          });
      });
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {}
    });
  },
  watch: {
    enterprises() {
      let vm = this;
      setTimeout(() => {
        window
          .jQuery(vm.$refs.tabs_layouts)
          .find(".item")
          .tab({
            onLoad(tabPath) {
              let targetEnterprise = vm.enterprises.find(
                (e) => e.uuid == tabPath
              );
              if (targetEnterprise) {
                vm.selected_enterprise = targetEnterprise;
                vm.users = vm.all_users.filter(
                  (u) => u.enterprise_id == targetEnterprise.enterprise_id
                );
                vm.roles = vm.all_roles.filter(
                  (u) => u.enterprise_id == targetEnterprise.enterprise_id
                );
                vm.modules = vm.all_modules.map((m) => {
                  m.granted = vm.permissions.find(
                    (p) =>
                      p.enterprise_id == targetEnterprise.enterprise_id &&
                      p.module_id == m.module_id
                  )
                    ? true
                    : false;
                  return m;
                });
              }
            }
          });
      }, 1000);
    }
  },
  updated: function() {},
  created() {
    let vm = this;

    if (vm.instance) {
      vm.uuid = vm.instance.uuid;
    }

    vm.reload();
  }
};
</script>
